import React from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Text } from 'components/forms'
import ContentBlock from 'components/ContentBlock'

const Bexio = ({ formData, onUpdate }) => {
	const [t] = useTranslation()

	const handleSubmit = values => {
		const secretIsChanged = values?.appConfigAdditional?.bexioApiToken !== formData?.appConfigAdditional?.bexioApiToken
		if(!secretIsChanged) {
			delete values?.appConfigAdditional?.bexioApiToken
		}
		onUpdate(values)
	}
	return(
		<ContentBlock label='Bexio'>
			<Form smartSubmit initialValues={formData} onSubmit={handleSubmit}>
				<Text type='password' disablePasswordAutoComplete label={t('common.fields.api_token')} field='appConfigAdditional.bexioApiToken'/>
			</Form>
		</ContentBlock>
	)
}

export default Bexio
